import { getCookie, removeCookie } from '@util/cookie';
/**
 * 灰度名单
 * {
 *   testKey: 灰度testKey,
 *   cookieName: cookie名，默认为testKey,
 *   cookieValue： cookie值，默认'Y',
 *   shouldReload: 是否reload当前页面
 * }
 * @type {*[]}
 */
export const grayList = [
  {
    cookieName: "must-food-agency-gray",
    cookieValue: "y",
    testKey: "pingxin_apollo_must_food"
  },
  'pingxin_food_name',  // 菜品名称长度限制
  {
    testKey: "pingxin_fe_show_history_menu",
    cookieValue: "y",
    cookieName: "pingxin_fe_show_history_menu"
  },
  {
    testKey: "pingxin_fe_service_center",
    cookieValue: "y",
    cookieName: "pingxin_fe_service_center"
  },
  'pingxin_fe_hq-static_wct',
  "pingxin_fe_bugfix_food_method", // 总部菜品编辑做法出现脏数据 bugfix
  {
    testKey: "pingxin_fe_system-download_trasnfer",
    cookieName: "mt_cloud",
    shouldReload: false,
  },
  {
    testKey: "pingxin_fe_report_v1_9",
    cookieName: "report-web-gray",
  },
  "pingxin_fe_discount-optimization", // 2.44 总部折扣交互优化
];
const cookiesToBeRemoved = [
  'pingxin_pay_web_2_37',  // 6月20日
  'pingxin_pay_settle_busType', // 支付明细表
  'pingxin_report_1_5', // 报表1.5需求
  'pingxin_report_1_5_new_report', // 新增报表
  'px_watch_storage', // 检测用户重复登录越权
  'batch_upload_image', // 批量上传图片
  'pingxin_apollo_publish_hotel_modify_price', // 2.40 门店修改总部下发菜品价格
  'pingxin_fe_dashboard_auth',
  "pingxin_apollo_search_food_in_menu", // 2.41 总部增加菜谱搜索
];
cookiesToBeRemoved.forEach(item => {
  removeCookie(item);
});

if (getCookie('feature_gray')) {
  removeCookie('feature_gray');
  window.location.reload();
}



// WEBPACK FOOTER //
// ./src/constants/gray.js